// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1L9Fm","active":"NavigationItem_active__3Z_Ez"};